import { cx } from '../utils/cx.js';
import styles from './Avatar.module.css';

export type AvatarPresence = 'online' | 'offline';

export type AvatarProps = {
  label: string;
  src?: string | null;
  /** `nav` = header account chip (uses `--wp-nav-avatar-size`). */
  size?: 'nav' | 'sm' | 'md' | 'lg';
  /** Accepted for staff threads. Dots stay off — no staff presence feed here. */
  presence?: AvatarPresence;
  className?: string;
};

export function Avatar({ label, src, size = 'md', presence: _presence, className }: AvatarProps) {
  void _presence;
  const trimmedSrc = src?.trim();
  if (trimmedSrc) {
    return (
      <span
        className={cx(styles.root, styles[size], styles.imageShell, className)}
        aria-hidden
        title={label}
      >
        <img src={trimmedSrc} alt="" className={styles.image} />
      </span>
    );
  }

  const initials = label
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0]?.toUpperCase())
    .join('');
  return (
    <span className={cx(styles.root, styles[size], className)} aria-hidden title={label}>
      {initials || '?'}
    </span>
  );
}
